import luxPopup from "../lux-popup.js";

const favorites = {
    toggle: function (element, productId) {
        const selectedListId = element.getAttribute("value");
        const selectedProductListId = element.getAttribute("id");
        var thisFavoriteList =
            ".favorite-list[data-id='" + selectedProductListId + "']";

        $(thisFavoriteList).toggleClass("favorite");

        if ($(thisFavoriteList).hasClass("favorite")) {
            $(thisFavoriteList).find("input").prop("checked", true);
        } else {
            $(thisFavoriteList).find("input").prop("checked", false);
        }

        this.toggleBadgeHeart(productId);

        fetch("/favorite/toggle/" + selectedListId, {
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                "X-Requested-With": "XMLHttpRequest",
                "X-CSRF-Token": window.CSRF_TOKEN,
            },
            method: "POST",
            body: JSON.stringify({
                productId: productId,
            }),
        });
    },

    openFavorites: function (e) {
        var $this = $(e);
        var listsContainer = $this.siblings(".favorite-lists-container");

        listsContainer.slideToggle({
            start: function () {
                $(this).css({
                    display: "flex",
                });
            },
        });

        $this.toggleClass("open");
    },

    initFavoritesSelector: function (id) {
        var swiperId = id.id;
        var initialized = false;

        if (initialized == false) {
            window.initializeSwiperScrollVertical(swiperId);
            initialized = true;
        }
    },

    toggleBadgeHeart: function (productId) {
        var favoriteBadgeWrapper = $(
            ".lux-badge-wrapper.favorites[data-id='" + productId + "']",
        );
        var favoriteBadge = $(favoriteBadgeWrapper).find(".lux-badge");
        var listsContainer = $(favoriteBadgeWrapper).siblings(
            ".favorite-lists-container",
        );

        if (listsContainer.find(".favorite-list.favorite").length) {
            $(favoriteBadgeWrapper).addClass("active");
            $(favoriteBadge).addClass("heart-full").removeClass("heart-empty");
        } else {
            $(favoriteBadgeWrapper).removeClass("active");
            $(favoriteBadge).removeClass("heart-full").addClass("heart-empty");
        }
    },
};

window.favorites = favorites;

const addCartProductFavorites = document.querySelectorAll(
    ".add-cart-product-favorites",
);

addCartProductFavorites.forEach(function (el) {
    el.addEventListener("click", function () {
        const cartProduct = el.closest(".lux-cart-product");

        const defaultList = cartProduct.querySelector(
            ".favorite-list input[data-is-default='1']",
        );

        const cartProductFavoritesToast = document.querySelector(
            ".toast-cart-product-added-favorites",
        );

        if (defaultList instanceof HTMLInputElement) {
            if (defaultList.checked) {
                // Remove and re-add to move to the top of favorites
                defaultList.click();

                setTimeout(() => {
                    defaultList.click();
                }, 50);
            } else {
                defaultList.click();
            }

            luxPopup.toastShow(cartProductFavoritesToast);
        }
    });
});
